<!-- 跨网交换解决方案 -->
<template>
  <div class="page_html">
    <div class="banner">
      <img
        src="@/assets/solution/enterprise/solution_banner.png"
        alt=""
      >
      <div class="banner_Title">
        <div class="title">
          {{ title }}
        </div>
        <div class="subtitle">
          {{ subtitle }}
        </div>
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        服务目标
      </p>
      <div class="content_A">
        跨网交换的目标是根据用户当前业务系统现状，结合文件交换、数据库同步、音视频传输及运维审计监控等业务需求，实现跨网、跨域安全隔离与信息交换。
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        跨网交换解决方案建设
      </p>
      <div class="content_A pic">
        <img
          src="@/assets/solution/crossNetwork/cross.png"
          alt=""
        >
      </div>
    </div>
    <div class="introduce bg">
      <div class="content_A pic ">
        <img
          src="@/assets/solution/crossNetwork/step.png"
          alt=""
        >
      </div>
    </div>

    <div class="introduce">
      <p class="sub_title">
        服务价值
      </p>

      <div class="content_A">
        <div class="values">
          <div
            v-for="item in values"
            :key="item.id"
            class="value"
          >
            <div class="number">
              {{ item.number }}
            </div>
            <div class="contents">
              {{ item.content }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CrossNetworkSwitching',
  data() {
    return {
      title: '跨网交换',
      subtitle: '在跨网、跨域业务数据交换中，实现安全隔离内网屏蔽，防护来自内外部的安全风险，成为跨网数据传输过程的基本需求。',
      values: [
        {
          id: 1,
          number: '01',
          content: '安全有效隔离多重网络，防护来自内外部的安全风险，提供多层次安全机制，满足跨网数据传输过程的基本需求'
        },
        {
          id: 2,
          number: '02',
          content: '精细控制数据流向，实现不同级别网络间安全可控的数据交换'
        },
        {
          id: 3,
          number: '03',
          content: '确保数据的机密性、完整性和可信性，助力用户在多网隔离场景下高效开展业务'
        }
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.page_html {
  height: 100%;

  .banner {
    width: 100wh;
    height: 550px;

    img {
      width: 100%;
      height: 100%;
    }

    .banner_Title {
      position: absolute;
      top: 15%;
      left: 15%;
      width: 80%;

      .title {
        width: 80%;
        font-size: 54px;
        color: #ffffff;
        font-weight: bold;
      }

      .subtitle {
        width: 80%;
        font-size: 36px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #FFFFFF;
        margin-top: 50px;
      }

    }
  }

  .pic {
    display: flex;
    justify-content: center;

    img{
      max-width: 100%;
    }
  }

  .bg {
    background: #FAFBFF;
    padding: 108px 0 89px;
  }

  .values {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .value {
      width: 32%;
      height: 500px;
      box-shadow: 0px 0px 16px 4px #D2DDFC;
      position: relative;

      &:nth-child(2) {
        background: rgba(69, 89, 233, 0.5);

        .content {
          color: #ffffff;
        }

        .contents{
          color: #ffffff;
        }
      }
    }

    .number {
      font-size: 100px;
      font-family: DIN;
      font-weight: bold;
      color: #4559E9;
      top: 40px;
      position: absolute;
      left: calc(50% - 61px);
    }

    .contents {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-top: 130px;
      padding: 0 102px;
    }
  }
}

@media screen and (min-width: 1200px) and (max-width: 1350px){
  .page_html .values .contents{
    padding: 0 63px;
  }
  .banner .banner_Title .subtitle,
  .introduce .content_A {
    font-size: 20px !important;
  }

   .banner .banner_Title .title {
    width: 100%;
    font-size: 37px !important;
  }

  .banner{
    height: 400px !important;
  }
}

@media screen and (min-width: 1350px) and (max-width: 1440px){
  .page_html .values .contents{
    padding: 0 63px;
  }
  .page_html .banner .banner_Title .title {
    font-size: 40px;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 25px;
  }

  .banner{
    height: 450px !important;
  }
}

@media screen and (min-width: 1440px) and (max-width: 1500px){
  .page_html .values .contents{
    padding: 0 73px;
  }
  .banner .banner_Title .title {
    font-size: 42px !important;
  }

  .page_html .banner .banner_Title .subtitle {
    font-size: 27px;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1700px){
  .page_html .values .contents{
    padding: 0 91px;
  }

  .banner .banner_Title .title {

    font-size: 52px !important;
  }

  .banner .banner_Title .subtitle {
    font-size: 30px !important;
  }

}
</style>
